<template>
    <view-card title="전문가 소개">
        <data-list :dataList="dataList" />
    </view-card>
</template>

<script>
import ViewCard from "./view-card.vue";
import DataList from "./data-list.vue";
export default {
    components: { ViewCard, DataList },
    props: {
        expert: Object,
    },
    computed: {
        dataList() {
            const list = [];

            const { nickname, summary } = this.expert;

            if (nickname) list.push({ term: "전문가", description: nickname });
            if (summary) list.push({ term: "전문가소개", description: summary, isPreLine: true });

            return list;
        },
    },
};
</script>

<style></style>
